import { createZodFormResolver, DateTimeUtils, useAppNowUtc, useFormControls, useTimezone } from '@mews/framework';
import { Container, Stack, StackItem, StructuredDate } from '@optimus-web/core';
import { LedgersDateField } from '../LedgersDateField';
import { LedgersDateValues, FiltersDateValueKey, createDateSchema } from './dateSchema';

interface LedgersDatePickerProps {
    selectedDate: string;
    setSelectedDate: (date: string) => void;
    effectiveDate?: string | null;
}

export const LedgersDatePicker = ({ selectedDate, setSelectedDate, effectiveDate }: LedgersDatePickerProps) => {
    const timezone = useTimezone();
    const nowUtc = useAppNowUtc();
    const nowDateTime = DateTimeUtils.dateTimeUtcStringToDate(nowUtc.value, timezone);
    const minDateTime = effectiveDate ? DateTimeUtils.dateTimeUtcStringToDate(effectiveDate, timezone) : undefined;

    const { renderFormContent } = useFormControls<LedgersDateValues>({
        id: 'ledgers-date',
        defaultValues: { date: selectedDate },
        mode: 'onChange',
        onSubmit: () => {},
        resolver: createZodFormResolver(createDateSchema(timezone, nowDateTime, minDateTime)),
    });

    const handleDateChange = (date: StructuredDate) => {
        setSelectedDate(DateTimeUtils.structuredDateToISOString(date));
    };

    const minDateStructuredDate = minDateTime ? DateTimeUtils.dateToStructuredDate(minDateTime) : undefined;
    return renderFormContent(
        <Container padding={['300', '300', '0', '300']}>
            <Stack alignment="end">
                <StackItem data-test-id="ledgers-date-picker">
                    <LedgersDateField
                        name={FiltersDateValueKey.date}
                        handleDateChange={handleDateChange}
                        minDate={minDateStructuredDate}
                    />
                </StackItem>
            </Stack>
        </Container>
    );
};
